import React, { useContext, useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Outlet } from "react-router-dom";
import { setToken } from "../../utils/OktaHelpers";
import SplashScreenView from "../../views/Shared/SplashScreenView";
import { UserContext } from "../../lib/MainContext";

export const SecureRoute = () => {
    const { oktaAuth, authState } = useOktaAuth();
    const redirectGuardKey = "okta_redirecting";
    const { initUtils, isLoggingOut, user } = useContext(UserContext);
    useEffect(() => {
        if (authState?.isAuthenticated) {
            oktaAuth.tokenManager.getTokens().then((tkn) => {
                if (tkn && (tkn.accessToken || tkn.idToken)) {
                    setToken(tkn);
                    initUtils();
                }
            });
        }
    }, [authState?.isAuthenticated]);

    useEffect(() => {
        if (!authState) return;
        if (isLoggingOut) return;

        if (authState.isAuthenticated) {
            sessionStorage.removeItem(redirectGuardKey);
            return;
        }

        if (!authState?.isAuthenticated) {
            const originalUri = toRelativeUrl(
                window.location.href,
                window.location.origin
            );
            oktaAuth.setOriginalUri(originalUri);
            oktaAuth.signInWithRedirect();
        }
    }, [oktaAuth, authState, authState?.isAuthenticated, isLoggingOut]);

    if (isLoggingOut || !user) {
        return <SplashScreenView />;
    }

    return <Outlet />;
};
